import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface SpecificationsProps {
  specifications: {
    modelName: string;
    dimensions: {
      metric: string;
      imperial: string;
    };
    weight: {
      metric: string;
      imperial: string;
    };
    build: string;
    sim: string;
    displayType: string;
    displaySize: string;
    additionalSpecs?: Record<string, string>;
  };
}
export const ExpandableSpecs = ({
  specifications
}: SpecificationsProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1127">
      <div className="bg-white p-4 flex justify-between items-center cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} data-id="element-1128">
        <h3 className="text-lg font-bold text-gray-800" data-id="element-1129">Specifications</h3>
        {isExpanded ? <ChevronUpIcon className="h-5 w-5 text-gray-600" data-id="element-1130" /> : <ChevronDownIcon className="h-5 w-5 text-gray-600" data-id="element-1131" />}
      </div>
      {isExpanded && <div className="bg-white p-6 border-t border-gray-200" data-id="element-1132">
          <div className="space-y-4" data-id="element-1133">
            <div data-id="element-1134">
              <div className="font-medium text-gray-800" data-id="element-1135">Model Name</div>
              <div className="text-gray-600" data-id="element-1136">{specifications.modelName}</div>
            </div>
            <div data-id="element-1137">
              <div className="font-medium text-gray-800" data-id="element-1138">Dimensions</div>
              <div className="text-gray-600" data-id="element-1139">
                {specifications.dimensions.metric} (
                {specifications.dimensions.imperial})
              </div>
            </div>
            <div data-id="element-1140">
              <div className="font-medium text-gray-800" data-id="element-1141">Weight</div>
              <div className="text-gray-600" data-id="element-1142">
                {specifications.weight.metric} ({specifications.weight.imperial}
                )
              </div>
            </div>
            <div data-id="element-1143">
              <div className="font-medium text-gray-800" data-id="element-1144">Build</div>
              <div className="text-gray-600" data-id="element-1145">{specifications.build}</div>
            </div>
            <div data-id="element-1146">
              <div className="font-medium text-gray-800" data-id="element-1147">SIM</div>
              <div className="text-gray-600" data-id="element-1148">{specifications.sim}</div>
            </div>
            <div data-id="element-1149">
              <div className="font-medium text-gray-800" data-id="element-1150">Display Type</div>
              <div className="text-gray-600" data-id="element-1151">{specifications.displayType}</div>
            </div>
            <div data-id="element-1152">
              <div className="font-medium text-gray-800" data-id="element-1153">Display Size</div>
              <div className="text-gray-600" data-id="element-1154">{specifications.displaySize}</div>
            </div>
            {showMore && specifications.additionalSpecs && Object.entries(specifications.additionalSpecs).map(([key, value]) => <div key={key} data-id="element-1155">
                    <div className="font-medium text-gray-800" data-id="element-1156">{key}</div>
                    <div className="text-gray-600" data-id="element-1157">{value}</div>
                  </div>)}
            {specifications.additionalSpecs && <button className="text-blue-600 font-medium hover:underline mt-2" onClick={e => {
          e.stopPropagation();
          setShowMore(!showMore);
        }} data-id="element-1158">
                {showMore ? 'See Less' : 'See More'}
              </button>}
          </div>
        </div>}
    </div>;
};